import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/** The SyntheticEvent object is not serialisable and cannot be passed to the runtime/backend as is.
 * This function filters out all non serialisable arguments and maintains important properties of the event object.
 */
var getSerialisableEventObject = function getSerialisableEventObject(syntheticEvent) {
  /** syntheticEvent.persist() is called to remove the synthetic event from React's event pool.
   * Without this call, the properties of the event would be nullified after the event callback has been invoked,
   * due to React's event pooling.
   * By calling persist(), we ensure that the event properties remain available for the serialization process.
   */
  syntheticEvent.persist();
  var target = syntheticEvent.target;
  var serialisableEvent = {
    bubbles: syntheticEvent.bubbles,
    cancelable: syntheticEvent.cancelable,
    defaultPrevented: syntheticEvent.defaultPrevented,
    eventPhase: syntheticEvent.eventPhase,
    isTrusted: syntheticEvent.isTrusted,
    target: {
      value: target === null || target === void 0 ? void 0 : target.value,
      checked: target === null || target === void 0 ? void 0 : target.checked,
      name: target === null || target === void 0 ? void 0 : target.name,
      id: target === null || target === void 0 ? void 0 : target.id,
      tagName: target === null || target === void 0 ? void 0 : target.tagName,
      type: target === null || target === void 0 ? void 0 : target.type
    },
    timeStamp: syntheticEvent.timeStamp,
    type: syntheticEvent.type
  };
  return serialisableEvent;
};

/**
 * Default handler args transformer that extract react synthetic event from
 * the handler args and creates a serialisable object so that it can be passed into the runtime.
 */
var nativeEventHandlerArgsTransformer = function nativeEventHandlerArgsTransformer() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var event = args[0],
    rest = args.slice(1);
  return [getSerialisableEventObject(event)].concat(_toConsumableArray(rest));
};

/**
 * @param sourceEventHandler the source event handler defined by the app user
 * @returns the adapted event handler that can be safely invoked.
 */
export var adaptEventHandler = function adaptEventHandler(sourceEventHandler) {
  if (!sourceEventHandler) {
    return sourceEventHandler;
  }
  return function () {
    sourceEventHandler.apply(void 0, _toConsumableArray(nativeEventHandlerArgsTransformer.apply(void 0, arguments)));
  };
};